//
// Generated class IntegratorMappingRule
//

/// <reference path="IntegratorMappingRule_ManagedObject.ts" />

class IntegratorMappingRule extends IntegratorMappingRule_ManagedObject
{

}
